import React from "react";
import Pagination from "react-js-pagination";
import { useNavigate } from "react-router-dom";

const Sivutus = (props) => {
  const { tila, asetatila } = props;
  const navigate = useNavigate();
  const handleChange = (props) => {
    asetatila("haku", { sivu: props });
    navigate("/");
  };
  // lasketaan sivut jakamalla tuotteiden lukumäärä sivun max-lkm:llä
  const sivuja = Math.ceil(tila.tuotteet.length / tila.korttiLkm);
  return (
    <Pagination
      totalItemsCount={tila.tuotteet.length}
      onChange={handleChange}
      activePage={Number(tila.haku.sivu)}
      itemsCountPerPage={tila.korttiLkm}
      pageRangeDisplayed={5}
      hideNavigation={true}
      activeLinkClass="linkActive"
      innerClass="sivutus"
      linkClass="link"
      linkClassFirst={
        tila.haku.sivu === 1 ? "linkActive isoTeksti" : "link isoTeksti"
      }
      linkClassLast={
        tila.haku.sivu === sivuja ? "linkActive isoTeksti" : "link isoTeksti"
      }
    />
  );
};
export default Sivutus;
